import { createStore } from "zustand/vanilla";
import { useStore } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

/**
 * The OneFront store object that could be used outside React components and hooks.
 */
export const OneFrontStore = createStore()(
  // TODO remove devTools before publish

  persist(
    (set) => ({
      /**
       * A flag that indicates if the store is loading.
       * @type {boolean}
       */
      loading: true,

      /**
       * The session data object.
       * @type {Object}
       */
      sessionData: {},

      /**
       * The storage data object.
       * @type {Object}
       */
      storageData: {},

      /**
       * Loads the session data from the query string.
       *
       * @param {Object} data - The session data to load.
       */
      loadFromQueryString: (data) =>
        data
          ? set({ sessionData: data, loading: false })
          : set({ loading: false }),

      /**
       * Sets a value in the session data object.
       * @param {string} key - The key of the value to set.
       * @param {*} value - The value to set.
       */
      setSessionData: (key, value) =>
        set((state) => ({
          sessionData: {
            ...state.sessionData,
            [key]: value
          }
        })),

      /**
       * Sets a value in the storage data object.
       * @param {string} key - The key of the value to set.
       * @param {*} value - The value to set.
       */
      setStorageData: (key, value) =>
        set((state) => ({
          storageData: {
            ...state.storageData,
            [key]: value
          }
        })),

      /**
       * Clears all data in the session and storage data objects.
       */
      clearAll: () => set({ sessionData: {}, storageData: {} }, true)
    }),
    {
      // TODO: find an arzigogolata way to get this from the app config>context
      name: "one.ctx",
      version: 1,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(([key]) => key !== "loading")
        )
    }
  )
);

/**
 * A custom hook that creates a Zustand store for OneFront.
 * @returns {Object} The OneFront store object.
 */
export const useOneFrontStore = (selector) => useStore(OneFrontStore, selector);
